import React, {useState} from "react";
import {handleRecoClick} from "../../common/services";
import ShopifyAddToCart from "./ShopifyAddToCart";
import {formatProductPrice} from "../utils/priceUtils";

const ProductCard = ({product, index, query = "", clientKey, currencyCode = null,roundingEnabled=null}) => {
    const [isHovered, setIsHovered] = useState(false);

    const plugin_platform = window.__VOICE_SEARCH_ENV_SETTINGS__.plugin_platform

    const handleClick = () => {
        handleRecoClick(product, {index, query, clientKey, recoSrc: "voice"});
    };


    return (
            <div
                className="flex flex-col rounded-lg overflow-hidden transition-all duration-300 cursor-pointer hover:shadow-lg justify-between"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={handleClick}
            >
                <div className="relative overflow-hidden rounded-lg border border-gray-100">
                    <img
                        src={product.image}
                        alt={product.name}
                        className={`w-full aspect-square object-contain transition-transform duration-500 ${
                            isHovered ? "scale-105" : ""
                        }`}
                    />
                </div>

                <div className="mt-2 px-2">
                    <h3 className="font-medium text-gray-800">{product.name}</h3>
                    <p className="mt-1 text-gray-600">{formatProductPrice(product.price, currencyCode,roundingEnabled)}</p>
                </div>

                <div className={`mt-3 px-2 ${plugin_platform !== 'shopify' ? 'hidden' : ''}`}>
                    {plugin_platform === "shopify" && (
                        <ShopifyAddToCart
                            product={product}
                            index={index}
                            query={query}
                            clientKey={clientKey}
                            currencyCode={currencyCode}
                            roundingEnabled={roundingEnabled}
                        />
                    )}
                </div>
            </div>

    );
};

export default ProductCard;
